module.exports = __webpack_public_path__ + "img/laboratorio_16-9_640.d6bc9444.webp";